import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

const Privacy = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main className="pt-20">
        <div className="max-w-4xl mx-auto px-4 py-12">
          <h1 className="text-4xl font-heading font-bold mb-6">Privacy Policy</h1>
          <p className="text-sm text-muted-foreground mb-8">Last updated: {new Date().toLocaleDateString('en-GB', { 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
          })}</p>
          
          <div className="prose prose-gray max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-heading font-semibold mb-4">1. Introduction</h2>
              <p className="text-muted-foreground leading-relaxed">
                Flexaura ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy 
                explains how we collect, use, disclose, and safeguard your information when you use our 
                financial marketplace platform.
              </p>
              <p className="text-muted-foreground leading-relaxed mt-4">
                <strong>Important:</strong> Flexaura operates solely as a marketplace that connects customers with 
                licensed financial partners for payment solutions. We do not provide credit, loans, or financing 
                directly, and we bear no credit risk. All financing is provided by our licensed partners.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold mb-4">2. Information We Collect</h2>
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-semibold mb-2">Personal Information</h3>
                  <p className="text-muted-foreground">
                    We may collect personal information such as name, email address, phone number, 
                    and other contact details when you sign up for our waitlist or use our services.
                  </p>
                </div>
                <div>
                  <h3 className="text-lg font-semibold mb-2">Usage Data</h3>
                  <p className="text-muted-foreground">
                    We collect information about how you interact with our platform, including 
                    pages visited, time spent, and user preferences.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold mb-4">3. How We Use Your Information</h2>
              <ul className="list-disc list-inside text-muted-foreground space-y-2">
                <li>To provide and maintain our services</li>
                <li>To communicate with you about updates and offers</li>
                <li>To improve our platform and user experience</li>
                <li>To comply with legal obligations</li>
                <li>To connect you with appropriate financial partners</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold mb-4">4. Information Sharing and Disclosure</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                As a marketplace, Flexaura shares your information with licensed financial partners 
                <strong> only for the purposes of processing eligibility assessments and facilitating checkout transactions</strong>. 
                We do not sell your personal information to third parties for marketing purposes.
              </p>
              <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-4">
                <p className="text-amber-800 font-medium">Key Points:</p>
                <ul className="list-disc list-inside text-amber-700 space-y-1 mt-2">
                  <li>Data sharing is limited to eligibility assessment and checkout processing only</li>
                  <li>We share information only with licensed, regulated financial partners</li>
                  <li>All credit and financing services are provided by partners, not Flexaura</li>
                  <li>Flexaura assumes no credit risk or liability for financing arrangements</li>
                </ul>
              </div>
              <p className="text-muted-foreground leading-relaxed">
                When you choose a payment option, you enter into a direct relationship with that financial partner. 
                Their privacy practices and data handling will be governed by their own privacy policies.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold mb-4">5. Data Security</h2>
              <p className="text-muted-foreground leading-relaxed">
                We implement appropriate security measures to protect your personal information 
                against unauthorized access, alteration, disclosure, or destruction. However, 
                no method of transmission over the internet is 100% secure.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold mb-4">6. Your Rights</h2>
              <p className="text-muted-foreground leading-relaxed">
                You have the right to access, update, or delete your personal information. 
                You may also opt out of certain communications from us. To exercise these rights, 
                please contact us using the information below.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold mb-4">7. Contact Us</h2>
              <p className="text-muted-foreground leading-relaxed">
                If you have any questions about this Privacy Policy or our data practices, please contact us:
              </p>
              <div className="bg-flexaura-gray/50 rounded-lg p-4 mt-4">
                <p className="font-semibold">Flexaura Marketplace</p>
                <p className="text-muted-foreground">Email: hector@flexaura.me</p>
                <p className="text-sm text-muted-foreground mt-2">
                  For the fastest response, please include "Privacy Policy" in your subject line.
                </p>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Privacy;